import { produce } from 'immer';
import * as types from './appDesignerTypes';
import createReducer from '../utils/createReducer';

const initialState = {
    // Currently selected device for preview and styling
    selectedDevice: types.DEVICE_TYPES.MOBILE,
    // Currently selected theme mode for preview
    selectedThemeMode: types.THEME_MODE_TYPES.LIGHT,
    // Active widget being edited (for live preview)
    activeWidgetPreview: null,
    // Navigation items preview (for live ManageNavigation updates)
    navigationPreview: null,
    // Cache for navigation widgets by page ID to avoid redundant fetches
    navigationWidgetsCache: {},
};

const actionHandlers = {
    [types.SET_SELECTED_DEVICE]: produce((draft, { payload }) => {
        draft.selectedDevice = payload;
    }),

    [types.SET_SELECTED_THEME_MODE]: produce((draft, { payload }) => {
        draft.selectedThemeMode = payload;
    }),

    [types.RESET_APP_DESIGNER]: produce((draft) => {
        draft.selectedDevice = types.DEVICE_TYPES.MOBILE;
        draft.selectedThemeMode = types.THEME_MODE_TYPES.LIGHT;
        draft.activeWidgetPreview = null;
        draft.navigationPreview = null;
        draft.navigationWidgetsCache = {};
    }),

    [types.SET_ACTIVE_WIDGET_PREVIEW]: produce((draft, { payload }) => {
        draft.activeWidgetPreview = payload;
    }),

    [types.CLEAR_ACTIVE_WIDGET_PREVIEW]: produce((draft) => {
        draft.activeWidgetPreview = null;
    }),

    [types.SET_NAVIGATION_PREVIEW]: produce((draft, { payload }) => {
        draft.navigationPreview = payload;
    }),

    [types.CLEAR_NAVIGATION_PREVIEW]: produce((draft) => {
        draft.navigationPreview = null;
    }),

    [types.SET_NAVIGATION_WIDGETS_CACHE]: produce((draft, { payload }) => {
        draft.navigationWidgetsCache[payload.pageId] = payload.widgets;
    }),

    [types.CLEAR_NAVIGATION_WIDGETS_CACHE]: produce((draft) => {
        draft.navigationWidgetsCache = {};
    }),
};

export default createReducer(initialState, actionHandlers);
